import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { IrisButtonModule } from '@sondermind/iris/button';
import { SharedFormPipesModule } from '@sondermind/iris/form-helpers';
import { IrisIconButtonModule } from '@sondermind/iris/icon-button';
import { IrisIconModule } from '@sondermind/iris/icon';

import { FilterSelectComponent } from './select.component';
import { SelectMenuComponent } from './select-menu/select-menu.component';
import { IsOptionInSelectionsPipe } from '../../pipes/is-option-in-selections.pipe';
import { JoinWithHyphensPipe } from '../../pipes/join-with-hyphens.pipe';

@NgModule({
  declarations: [
    FilterSelectComponent,
    SelectMenuComponent
  ],
  exports: [
    FilterSelectComponent,
  ],
  imports: [
    CommonModule,
    IrisButtonModule,
    IrisIconModule,
    IrisIconButtonModule,
    IsOptionInSelectionsPipe,
    JoinWithHyphensPipe,
    ReactiveFormsModule,
    SharedFormPipesModule
  ],
  providers: [{ provide: 'Window', useValue: window }]
})
export class FilterSelectModule { }
